module.exports = {"341621001":"城关街道","341621003":"星园街道","341621004":"天静宫街道","341621103":"西阳镇","341621104":"涡南镇","341621105":"楚店镇","341621106":"高公镇","341621108":"高炉镇","341621109":"曹市镇","341621110":"青疃镇","341621111":"石弓镇","341621112":"龙山镇","341621113":"义门镇","341621114":"新兴镇","341621115":"临湖镇","341621116":"丹城镇","341621117":"马店集镇","341621118":"花沟镇","341621119":"店集镇","341621120":"陈大镇","341621121":"牌坊镇","341621122":"公吉寺镇","341621123":"标里镇","341621402":"安徽涡阳经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341621.json
// module id = 1253
// module chunks = 0